import { render, staticRenderFns } from "./UnpaidOrderCommentModal.vue?vue&type=template&id=5b8819dc&scoped=true"
import script from "./UnpaidOrderCommentModal.vue?vue&type=script&lang=js"
export * from "./UnpaidOrderCommentModal.vue?vue&type=script&lang=js"
import style0 from "./UnpaidOrderCommentModal.vue?vue&type=style&index=0&id=5b8819dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8819dc",
  null
  
)

export default component.exports